export const nativeBridge = {
  exec: (functionName, args) => {
    const isAndroid = window.USER?.agent?.isAndroid;

    if (isAndroid) {
      window.android?.[functionName]?.(args);
    } else {
      window.webkit?.messageHandlers?.[functionName]?.postMessage?.(args ?? '');
    }
  },
};
